var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConsensionary(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 4.0625H13.75C13.9802 4.0625 14.1667 3.8807 14.1667 3.65625V2.71908C14.1667 2.54973 14.0589 2.39814 13.8964 2.33873L7.79271 0.0517969C7.69844 0.0172656 7.59922 0 7.5 0C7.40078 0 7.30156 0.0172656 7.20729 0.0517969L1.10365 2.33873C1.02425 2.36778 0.955825 2.41975 0.907523 2.48772C0.859222 2.55568 0.83334 2.6364 0.833333 2.71908V3.65625C0.833333 3.8807 1.01979 4.0625 1.25 4.0625ZM7.5 1.2477L11.7599 2.84375H3.2401L7.5 1.2477ZM14.5833 11.7812H14.1667V10.1562C14.1667 9.7076 13.7404 9.34375 13.2143 9.34375H12.5V4.875H11.25V9.34375H9.58333V4.875H8.33333V9.34375H6.66667V4.875H5.41667V9.34375H3.75V4.875H2.5V9.34375H1.78568C1.25964 9.34375 0.833333 9.7076 0.833333 10.1562V11.7812H0.416667C0.186458 11.7812 0 11.963 0 12.1875V12.5938C0 12.8182 0.186458 13 0.416667 13H14.5833C14.8135 13 15 12.8182 15 12.5938V12.1875C15 11.963 14.8135 11.7812 14.5833 11.7812ZM12.9167 11.7812H2.08333V10.5625H12.9167V11.7812Z",
    fill: "#155892"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsensionary);
export default __webpack_public_path__ + "static/media/consensionary.7f088a244ab0a4982d67c579c85f37e5.svg";
export { ForwardRef as ReactComponent };